import React from 'react';

import styled from '@emotion/styled';
import { DesignsToken } from '@repo/tokens-studio';

import { Lottie } from '@web/ui/lottie/Lottie';

import UnaIconSvg from './una-icon.svg';

const UnaIconContainer = styled.div`
  display: flex;
`;

const SvgContainer = styled(UnaIconSvg)<{ size: keyof DesignsToken['size'] }>`
  width: ${({ theme, size }) => theme.size[size]};
  height: auto;
`;

const StyledLottie = styled(Lottie)<{ size: keyof DesignsToken['size'] }>`
  width: ${({ theme, size }) => theme.size[size]};
`;

export interface IUnaIconProps {
  animated?: boolean;
  size: keyof DesignsToken['size'];
  className?: string;
}

export const UnaIcon = ({ animated, className, size }: IUnaIconProps) => {
  return (
    <UnaIconContainer className={className}>
      {animated ? (
        <StyledLottie
          animationParams={{
            renderer: 'svg',
            autoplay: true,
            loop: true,
            rendererSettings: { viewBoxOnly: true },
          }}
          size={size}
          fromURL={`${location.origin}/lottie/una.lottie`}
          StaticSVG={UnaIconSvg}
        />
      ) : (
        <SvgContainer size={size} />
      )}
    </UnaIconContainer>
  );
};
